import { render, staticRenderFns } from "./AffiliateGroups.vue?vue&type=template&id=759b99d7&"
import script from "./AffiliateGroups.vue?vue&type=script&lang=js&"
export * from "./AffiliateGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports